module.exports = __webpack_public_path__ + "static/media/sala_principal_6.d6647f25.jpg";